module.exports = {"seo_sub_category":{"faqs":{"title":"%{sub_category_title} FAQs"},"tags":{"title":"Service Related To %{sub_category_title}"}}}


//////////////////
// WEBPACK FOOTER
// ./src/translations.en.json
// module id = eIBB
// module chunks = 0